import React, { useEffect } from 'react'
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MUIDataTable from "mui-datatables";
import { createMuiTheme, TextField, makeStyles, MuiThemeProvider, Paper, Switch, TableCell, Tabs, Tab, Typography, withStyles, Snackbar } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseImage from '../../assets/ic_close.png';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import { format } from 'date-fns';
import { useHistory, useLocation } from 'react-router-dom';
import line from '../../assets/line grey.png';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function EditJadwal(props) {
    const history = useHistory()
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const location = useLocation()
    console.log(location, '<<<<<<<<<<<<<');
    const classes = useStyles()
    let detail = location.state.sentData
    let listSchedule = location.state.detail[0].effective_date[0].schedule
    console.log(listSchedule);
    const efDate = location.state.efDate
    const timeStart = detail[1].slice(0, 5)
    const timeEnd = detail[2].slice(0, 5)
    console.log(detail, '<<<<<<');
    const [data, setData] = React.useState(null)
    const [hari, setHari] = React.useState(null)
    const [time_start, set_time_start] = React.useState(new Date(`${efDate} ${timeStart}`))
    // console.log(efDate);
    const [time_end, set_time_end] = React.useState(new Date(`${efDate} ${timeEnd}`))
    const [time_type, set_time_type] = React.useState(null)
    const [time, set_time] = React.useState(`${detail[4]}`)
    const [service_duration, set_service_duration] = React.useState(null)
    const [quota, set_quota] = React.useState(detail[6])
    const [list_room, set_list_room] = React.useState([])
    const [quota_bpjs, set_quota_bpjs] = React.useState(detail[7])
    const [service_type, set_service_type] = React.useState(null)
    const [room, set_room] = React.useState(null)
    const [tanggal, setTanggal] = React.useState(new Date(location.state.efDate))
    const [notesDokter, setNotesDokter] = React.useState(null)
    const [visibleNotes, setVisibleNotes] = React.useState(false)
    const [createdAt, setCreatedAt] = React.useState(detail[13])
    const [createdBy, setCreatedBy] = React.useState(detail[14])
    const [updatedAt, setUpdatedAt] = React.useState(detail[15])
    const [updatedBy, setUpdatedBy] = React.useState(detail[16])
    const [deletedAt, setDeletedAt] = React.useState(detail[17])
    const [deletedBy, setDeletedBy] = React.useState(detail[18])


    React.useEffect(() => {
        setNotesDokter(location.state.value.notes)
        set_service_duration(detail[5])
        getRuangan()
    }, [])

    const getRuangan = () => {
        api.create().getRoomFilter("activeinactive=1").then(response => {
            let listRoom = []
            response.data.data.map((el, idx) => {
                listRoom.push({
                    id: el.id,
                    name: `Gd. ${el.building_name}, Lantai.${el.floor}, Ruangan ${el.name}`
                })
            })
            set_list_room(listRoom)
        })
    }

    const [listHari, setListHari] = React.useState([
        { id: 1, name: "Senin" },
        { id: 2, name: "Selasa" },
        { id: 3, name: "Rabu" },
        { id: 4, name: "Kamis" },
        { id: 5, name: "Jum'at" },
        { id: 6, name: "Sabtu" },
        { id: 7, name: "Minggu" },
    ])

    const [listJam, setListJam] = React.useState([
        { name: `${detail[1]}` },
        { name: `${detail[2]}` },
        // { name: "09:00:00" },
        { name: "10:00:00" },
        { name: "11:00:00" },
    ])

    const [listRoom, setListRoom] = React.useState([
        { name: "Gd. Anggrek, Lantai.1, Ruangan AGR12" },
        { name: "Gd. Anggrek, Lantai.2, Ruangan AGR12" },
    ])

    const [listTipeAntrian, setListTipeAntrian] = React.useState([
        { name: "TIMESLOT", id: 1 },
        { name: "TIMEBLOK", id: 2 },
        { name: "FIFO", id: 3 },
        { name: "FIFO CHECKIN", id: 4 },
    ])

    const [listLayanan, setListLayanan] = React.useState([
        {
            id: 1,
            name: "BPJS"
        },
        {
            id: 2,
            name: "UMUM"
        },
        {
            id: 3,
            name: "BPJS/UMUM"
        },
    ])

    const [listSlotWaktu, setListSlotWaktu] = React.useState([
        { name: "15" },
        { name: "14" },
    ])

    const [listQuota, setListQuota] = React.useState([
        { name: "10" },
        { name: "11" },
        { name: "12" },
        { name: "13" },
        { name: "14" },
        { name: "15" },
        { name: "22" },
        { name: detail[6] },
    ])

    const [listTime, setListTime] = React.useState([
        {
            id: 0,
            name: time
        },
        { name: "11" },
        // { name: "10" },
        { name: "12" },
        { name: "13" },
        { name: "14" },
        { name: "15" },
        { name: "16" },
        { name: "17" },
        { name: "18" },
        { name: "19" },
        { name: "20" },
        { name: "21" },
        { name: "22" },
        { name: "23" },
        { name: "24" },
        { name: "25" },
        { name: "26" },
        { name: "27" },
        { name: "28" },
        { name: "29" },
        { name: "30" },
        { name: "60" },
    ])

    React.useEffect(() => {
        let indexHari = listHari.findIndex((val) => val.name === detail[0])
        let indexStart = listJam.findIndex((val) => val.name === detail[1])
        let indexEnd = listJam.findIndex((val) => val.name === detail[2])
        let indexTypeQueue = listTipeAntrian.findIndex((val) => val.name === detail[3])
        console.log(indexTypeQueue);
        let indexTime = listTime.findIndex((val) => val.name == time)
        // let indexDurasi = listDurasi.findIndex((val) => val.name == detail[5])
        let indexQuota = listQuota.findIndex((val) => val.name == detail[6])
        let indexQuotaBpjs = listQuota.findIndex((val) => val.name == detail[7])
        let indexServiceType = listLayanan.findIndex((val) => val.name === detail[8])
        if (list_room) {
            let indexRoom = list_room.findIndex((val) => val.name === detail[9])
            set_room(list_room[indexRoom])
        }
        setHari(listHari[indexHari])
        // let dateCreational = listSchedule.findIndex((val) => val.hari === detail[0])
        // setUpdatedBy(listSchedule[dateCreational].updated_by)
        // setUpdatedAt(listSchedule[dateCreational].updated_at)
        // setCreatedBy(listSchedule[dateCreational].created_by)
        // setCreatedAt(listSchedule[dateCreational].created_at)
        // setDeletedBy(listSchedule[dateCreational].deleted_by)
        // setDeletedAt(listSchedule[dateCreational].deleted_at)
        // set_time_end(listJam[indexEnd])
        // set_time_start(listJam[indexStart].name)
        // console.log(indexTime);
        // if (indexTime >= 0) {
        //     set_time(listTime[indexTime].name)
        // } else {
        //     set_time('-')
        // }
        // set_quota(listQuota[indexQuota])
        // set_quota_bpjs(listQuota[indexQuotaBpjs])
        set_time_type(listTipeAntrian[indexTypeQueue])
        set_service_type(listLayanan[indexServiceType])
    }, [list_room])

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleChange = (e) => {
        // set_room(e.target.value)
        console.log(e.target.value, '---------');
    }
    // console.log(time_start);
    // console.log(time_end);

    const listAntrian = [
        {
            id: 1,
            name: "BPJS"
        },
        {
            id: 2,
            name: "Umum"
        },
        {
            id: 3,
            name: "BPJS/Umum"
        },
    ]

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleBatal = () => {
        history.goBack()
    }

    // console.log(time);

    const handleSubmit = () => {
        console.log(tanggal)
        console.log(time_start)
        console.log(time_type)
        console.log(quota)
        console.log(quota_bpjs)
        console.log(hari)
        console.log(time_end)
        console.log(time)
        console.log(service_type)
        console.log(room)
        console.log(service_duration);

        let schedule = [
            {
                "day_id": hari.id,
                "session": [
                    {
                        "service_type": service_type && service_type.id,
                        "time_type": time_type === null ? null : time_type.id,
                        "time": time,
                        "service_duration": service_duration,
                        "quota": quota === undefined ? detail[6] : quota,
                        "quota_bpjs": quota_bpjs === undefined ? detail[7] : quota_bpjs,
                        "time_start": format(time_start, 'HH:mm'),
                        "time_end": format(time_end, 'HH:mm'),
                        "room_id": room.id
                    }
                ]
            }
        ]
        let body = {
            "id": detail[19],
            "quota": quota === undefined ? detail[6] : quota,
            "quota_bpjs": quota_bpjs === undefined ? detail[7] : quota_bpjs,
            "room_id": room.id,
            "service_type": service_type && service_type.id,
            "time": +time,
            "service_duration": service_duration,
            "time_end": format(time_end, 'HH:mm'),
            "time_start": format(time_start, 'HH:mm'),
            "time_type": time_type === null ? null : time_type.id,
            "day_id": hari.id,
        }
        console.log(body);
        let payload = {
            "id": detail[11],
            "effective_date": location.state.efDate,
            "schedule": schedule,
        }
        api.create().editMasterJadwal(body).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("Success")
                    setTimeout(() => {
                        history.goBack()
                    }, 500);
                }
            }
        })
    }

    console.log(time);

    return (
        <div>
            {
                location.state.isEdit === false ?
                    <div>
                        <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                            <Alert onClose={handleClose} severity={statusAlert}>
                                {messageAlert}
                            </Alert>
                        </Snackbar>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ paddingRight: 30, paddingLeft: 30, marginTop: 20 }}>
                            <div className="column-1" style={{ width: '80%' }}>
                                <Typography style={{ fontFamily: 'poppins', letterSpacing: 0.5, color: '#2A9C6C' }}>{location.state.name} </Typography>
                                <Typography style={{ fontFamily: 'poppins', letterSpacing: 0.5, color: '#a4a4a4', fontSize: 15 }}>Klinik {location.state.detail[0].polyclinic_name} </Typography>
                            </div>
                            <div className="column-2" style={{}}>
                                <TextField
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    multiline
                                    maxRows={2}
                                    rows={2}
                                    InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            letterSpacing: 1.5, color: '#a4a4a4', fontSize: 14
                                        }
                                    }}
                                    value={notesDokter}
                                />
                                {notesDokter && notesDokter.length > 20 && (
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}
                                        onClick={() => {
                                            setVisibleNotes(true)
                                        }}
                                    >
                                        <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, margin: 'auto' }}>
                            <div className="column-1" style={{}}>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggalBerlaku"
                                            label="Tanggal Berlaku"
                                            format="dd/MM/yyyy"
                                            disabled={true}
                                            // minDate={new Date()}
                                            value={tanggal}
                                            onChange={(date) => {
                                                setTanggal(date)
                                                forceUpdate()
                                            }}
                                            InputProps={{

                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%' }}
                                        />
                                    </MuiPickersUtilsProvider>

                                </div>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            style={{ width: '100%', marginTop: 15 }}
                                            margin="normal"
                                            id="jamMulai"
                                            disabled={true}
                                            clearLabel
                                            ampm={false}
                                            label="Jam Mulai"
                                            value={time_start}
                                            onChange={(date) => set_time_start(date)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                            InputProps={{

                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>

                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        options={listTipeAntrian}
                                        style={{ width: '100%', marginTop: 15 }}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        disabled
                                        name='Tipe Antrian'
                                        value={time_type}
                                        id="tipeAntrian"
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 }, }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Tipe Antrian"
                                            />
                                        }
                                        InputProps={{

                                        }}
                                    />

                                </div>

                                <div>
                                    <TextField
                                        style={{ marginTop: 15, width: '100%' }}
                                        id="durasi"
                                        name="Durasi"
                                        disabled
                                        label="Durasi Layanan"
                                        value={service_duration ? service_duration : "-"}
                                        placeholder={"10"}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>

                                <div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 15 }}
                                        id="kuotaPasien"
                                        name="Kuota Pasien"
                                        disabled
                                        label="Kuota Pasien"
                                        value={detail[6] || "-"}
                                        inputProps={{
                                            style: {
                                                // color: 'black'
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>
                                <div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 15 }}
                                        id="kuotaPasienBpjs"
                                        name="Kuota Pasien BPJS"
                                        label="Kuota Pasien BPJS"
                                        value={detail[7] || "-"}
                                        placeholder={"10"}
                                        disabled
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>
                                <div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 15 }}
                                        label="Catatan Publik"
                                        value={detail[10] || "-"}
                                        disabled
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>
                            </div>

                            <div className="column-2">
                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        style={{ width: '100%', marginTop: 19, marginBottom: 8 }}
                                        options={listHari}
                                        debug
                                        getOptionLabel={(option) => option.name}
                                        disabled
                                        name='hari'
                                        id="hari"
                                        value={hari}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 }, }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Hari"
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin="normal"
                                            style={{ marginTop: 15, width: '100%' }}
                                            id="jamSelesai"
                                            clearLabel
                                            disabled
                                            ampm={false}
                                            label="Jam Selesai"
                                            value={time_end}
                                            onChange={(date) => set_time_end(date)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                            InputProps={{

                                            }}
                                        />

                                    </MuiPickersUtilsProvider>
                                </div>
                                <div>
                                    <TextField
                                        style={{ marginTop: 15, width: '100%' }}
                                        id="slotWaktu"
                                        name="Slot Waktu"
                                        disabled
                                        label="Slot Waktu"
                                        value={time}
                                        placeholder={"10"}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>
                                <div>
                                    <Autocomplete
                                        // multiple
                                        options={listAntrian}
                                        style={{ marginTop: 19, width: '100%' }}
                                        getOptionLabel={(option) => option.name}
                                        getOptionDisabled={(option) =>
                                            // console.log(detail[7]);
                                            detail[8] === "UMUM" && option.id === 1 ||
                                            detail[8] === "BPJS" && option.id === 2 ||
                                            detail[8] === "BPJS/UMUM" && option.id === 1 ||
                                            detail[8] === "BPJS/UMUM" && option.id === 2
                                            // option.index !== slotWaktu.length - 1 && option.is_available === "Tidak Tersedia"
                                        }
                                        name='Layanan Pasien'
                                        id="layananPasien"
                                        value={service_type}
                                        onChange={(event, newInputValue) => {
                                            set_service_type(newInputValue)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 }, }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Layanan Pasien"
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        style={{ marginTop: 19, width: '100%' }}
                                        options={list_room}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        name='Lokasi Praktek'
                                        disabled
                                        id="lokasiPraktek"
                                        value={room}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 }, }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Lokasi Praktek"
                                            />
                                        }
                                    />

                                </div>
                                <TextField
                                    style={{ width: '100%', marginTop: 15 }}
                                    label="Catatan Internal"
                                    value={detail[15] || "-"}
                                    disabled
                                    inputProps={{
                                        style: {

                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                    InputProps={{

                                    }}
                                />
                            </div>
                        </div>

                        <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18, marginTop: 30, marginLeft: 30 }}>Status</Typography>
                        <div className="grid grid-3x grid-mobile-none gap-15px" style={{ padding: '20px 50px' , paddingLeft: 50, margin: 'auto' }}>
                            <div className="column-1">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Created By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{createdBy === null ? "-" : createdBy === "" ? "-" : createdBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Created at</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{createdAt === null ? "-" : createdAt === "" ? "-" : createdAt}</Typography>
                            </div>
                            <div className="column-2">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Updated By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{updatedBy === null ? "-" : updatedBy === "" ? "-" : updatedBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Updated At</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{updatedAt === null ? "-" : updatedAt === "" ? "-" : updatedAt}</Typography>
                            </div>
                            <div className="column-3">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Deleted By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{deletedBy === null ? "-" : deletedBy === "" ? "-" : deletedBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Deleted At</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{deletedAt === null ? "-" : deletedAt === "" ? "-" : deletedAt}</Typography>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div onClick={() => history.goBack()} style={{ backgroundColor: 'white', borderRadius: 70, textAlign: 'center', width: 205, height: 39, color: '#278863', border: "2px solid #278863", marginTop: 17, cursor: 'pointer', marginRight: 20 }}>
                                <Typography style={{ marginTop: 4 }}>Kembali</Typography>
                            </div>
                            <div onClick={() => handleSubmit()} style={{ backgroundColor: '#278863', borderRadius: 70, textAlign: 'center', width: 205, height: 39, color: '#278863', border: "2px solid #278863", marginTop: 17, cursor: 'pointer' }}>
                                <Typography style={{ marginTop: 4, color: 'white' }}>Simpan</Typography>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                            <Alert onClose={handleClose} severity={statusAlert}>
                                {messageAlert}
                            </Alert>
                        </Snackbar>
                        <Typography style={{ paddingTop: 30, paddingLeft: 33, fontFamily: 'poppins', letterSpacing: 0.5, color: '#2A9C6C' }}>{location.state.name} </Typography>
                        <Typography style={{ paddingTop: 10, paddingLeft: 33, fontFamily: 'poppins', letterSpacing: 0.5, color: '#a4a4a4', fontSize: 15 }}>Klinik {location.state.detail[0].polyclinic_name} </Typography>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, margin: 'auto', width: '80%' }}>
                            <div className="column-1">
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggalBerlaku"
                                            label="Tanggal Berlaku"
                                            format="dd/MM/yyyy"
                                            // minDate={new Date()}
                                            disabled={true}
                                            value={tanggal}
                                            onChange={(date) => {
                                                setTanggal(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%', marginTop: 12 }}
                                            InputProps={{

                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>

                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            style={{ width: '100%', marginTop: 15 }}
                                            margin="normal"
                                            id="jamMulai"
                                            clearLabel
                                            ampm={false}
                                            disabled={true}
                                            label="Jam Mulai"
                                            value={time_start}
                                            onChange={(date) => set_time_start(date)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>

                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        options={listTipeAntrian}
                                        style={{ width: '100%', marginTop: 15 }}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        disabled={true}
                                        name='Tipe Antrian'
                                        value={time_type}
                                        id="tipeAntrian"
                                        onChange={(event, newInputValue) => {
                                            set_time_type(newInputValue)
                                            // set_data({
                                            //     ...data,
                                            //     "time_type": newInputValue.name
                                            // })
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Tipe Antrian"
                                            />
                                        }
                                    />
                                </div>

                                <div>
                                    <TextField
                                        style={{ marginTop: 15, width: '100%' }}
                                        id="durasi"
                                        name="Durasi"
                                        disabled={true}
                                        label="Durasi Layanan"
                                        value={service_duration === null ? "-" : service_duration}
                                        placeholder={"10"}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>

                                <div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 15 }}
                                        id="kuotaPasien"
                                        name="Kuota Pasien"
                                        label="Kuota Pasien"
                                        value={quota || "-"}
                                        disabled={true}
                                        placeholder={"10"}
                                        onChange={(e) => {
                                            set_quota(e.target.value)
                                            // set_data({
                                            //     ...data,
                                            //     "quota": +e.target.value
                                            // })
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 15 }}
                                        id="kuotaPasienBpjs"
                                        name="Kuota Pasien BPJS"
                                        label="Kuota Pasien BPJS"
                                        value={quota_bpjs || "-"}
                                        disabled={true}
                                        placeholder={"10"}
                                        onChange={(e) => {
                                            set_quota_bpjs(e.target.value)
                                            // set_data({
                                            //     ...data,
                                            //     "quota_bpjs": +e.target.value
                                            // })
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 15 }}
                                        label="Catatan Publik"
                                        value={detail[10] || "-"}
                                        disabled
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>
                            </div>

                            <div className="column-2">
                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        style={{ marginTop: 16, width: '100%' }}
                                        options={listHari}
                                        debug
                                        getOptionLabel={(option) => option.name}
                                        disabled={true}
                                        name='hari'
                                        id="hari"
                                        value={hari}
                                        onChange={(event, newInputValue) => {
                                            // console.log(newInputValue);
                                            // if (newInputValue.length > 0) {
                                            //     let temp = []
                                            //     newInputValue.map((el, idx) => {
                                            //         temp.push(el.name)
                                            //         set_data({
                                            //             ...data,
                                            //             "hari": temp
                                            //         })
                                            //     })
                                            // } else {

                                            // }
                                            setHari(newInputValue)
                                            // set_data({
                                            //     ...data,
                                            //     "hari": newInputValue.name
                                            // })
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Hari"
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin="normal"
                                            style={{ marginTop: 23, width: '100%' }}
                                            id="jamSelesai"
                                            clearLabel
                                            ampm={false}
                                            label="Jam Selesai"
                                            disabled={true}
                                            value={time_end}
                                            onChange={(date) => set_time_end(date)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div>
                                    <TextField
                                        style={{ marginTop: 12, width: '100%' }}
                                        id="slotWaktu"
                                        name="Slot Waktu"
                                        label="Slot Waktu"
                                        value={time}
                                        placeholder={"10"}
                                        disabled={true}
                                        onChange={(e) => {
                                            set_time(e.target.value)
                                            // set_data({
                                            //     ...data,
                                            //     "time": +e.target.value
                                            // })
                                        }}
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <Autocomplete
                                        // multiple
                                        options={listAntrian}
                                        style={{ marginTop: 17, width: '100%' }}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        disabled={true}
                                        name='Layanan Pasien'
                                        id="layananPasien"
                                        value={service_type}
                                        onChange={(event, newInputValue) => {
                                            set_service_type(newInputValue)
                                            // set_data({
                                            //     ...data,
                                            //     "service_type": newInputValue.name
                                            // })
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Layanan Pasien"
                                            />
                                        }
                                    />
                                </div>
                                <div className="">
                                    <Autocomplete
                                        // multiple
                                        style={{ marginTop: 20, width: '100%' }}
                                        options={list_room}
                                        getOptionLabel={(option) => option.name}
                                        debug
                                        disabled={true}
                                        name='Lokasi Praktek'
                                        id="lokasiPraktek"
                                        value={room}
                                        onChange={(event, newInputValue) => {
                                            // set_room(newInputValue ? newInputValue.name : "")
                                            set_room(newInputValue)
                                            // set_data({
                                            //     ...data,
                                            //     "room": newInputValue.name
                                            // })
                                            // setFlagging(true)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Lokasi Praktek"
                                            />
                                        }
                                    />
                                </div>
                                <div>
                                    <TextField
                                        style={{ width: '100%', marginTop: 15 }}
                                        label="Catatan Internal"
                                        value={detail[15] || "-"}
                                        disabled
                                        inputProps={{
                                            style: {

                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{

                                        }}
                                    />

                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {/* <div onClick={() => handleBatal()} style={{ backgroundColor: '#278863', borderRadius: 70, textAlign: 'center', width: 160, height: 39, color: 'white', border: "2px solid #278863", marginTop: 47, cursor: 'pointer' }}>
                                <Typography style={{ marginTop: 4 }}>Kembali</Typography>
                            </div> */}
                            {detail[11] === null &&
                                <div>
                                    <div onClick={() => handleBatal()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 70, marginRight: 10, cursor: 'pointer', marginTop: 48, }}>
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div onClick={() => handleSubmit()} style={{ backgroundColor: 'white', borderRadius: 70, textAlign: 'center', width: 205, height: 39, color: '#278863', border: "2px solid #278863", marginTop: 47, cursor: 'pointer' }}>
                                        <Typography style={{ marginTop: 4 }}>Simpan</Typography>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
            }
            {visibleNotes && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div style={{ padding: 20 }}>
                            <textarea
                                value={notesDokter}
                                disabled
                                style={{ width: '100%', marginTop: 10, minHeight: 400 }}
                            />
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleNotes(false)}
                                    style={{ height: 28, width: 100, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <Typography style={{ color: 'white', fontSize: 13 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}